<template lang="pug">
.sidebar
  .topnavbar
    .con
      .nlbar
        .logo
          router-link(to="/" @click.native="toggleSidebar()")
            img(src='/new/img/logo.png')
        language
  .items.sp
    template(v-if="isLoggedIn")
      router-link.btns.deposit(to="/deposit" @click.native="toggleSidebar()")
        span {{$t('ui.deposit')}}
        img(src='/new/img/menu/sm-deposit.png')
      router-link.btns.vip(to="/vip" @click.native="toggleSidebar()")
        span VVIP
        //- img(src='/new/img/menu/sm-vip.png')
        img(src='/new/img/menu/vvip.png')
      router-link.btns.referral(to="/referral" @click.native="toggleSidebar()")
        span {{$t('ui.referral')}}
        img(src='/new/img/menu/sm-referral.png')
      router-link.btns.inbox-s(to='/inbox' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/inbox'}")
        span {{$t('ui.inbox')}}
        img(src='/new/img/menu/sm-inbox.png')
    template(v-else)
      router-link.btns.referral(to="/referral" @click.native="toggleSidebar()")
        span {{$t('ui.referral')}}
        img(src='/new/img/menu/sm-referral.png')
      a.btns.livechat(href="javascript:void(0)" @click="openChat();toggleSidebar()")
        span {{$t('ui.livechat')}}
        img(src='/new/img/menu/sm-livechat.png')
      router-link.btns.review(to='/review' @click.native="toggleSidebar()")
        span {{$tc('ui.review')}}
        img(src='/new/img/menu/sm-review.png')
      a.btns.inbox-s(href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
        span {{$t('ui.inbox')}}
        img(src='/new/img/menu/sm-inbox.png')
    router-link.btns.checkin(to="/daily-check-in" @click.native="toggleSidebar()")
      span {{$t('ui.dailycheckin')}}
      img(src='/new/img/menu/sm-checkin.png')
  .items
    //- router-link.btns(to='/highlights' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/highlights'}")
      span {{$t('ui.highlights')}}
      img(src='/new/img/menu/new-icon.png')
    router-link.btns(to='/promotions' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/promotions'}")
      span {{$t('ui.promotions')}}
      img(src='/new/img/menu/m-promo.png')
    //- router-link.btns(to='/missions')
      span Mission
      img(src='/new/img/menu/m-mission.png')
    template(v-if="isLoggedIn")
      router-link.btns(to='/statement' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/statement'}")
        span {{$t('ui.statement')}}
        img(src='/new/img/menu/m-statement.png')
      a.btns(href="javascript:void(0)" @click="openChat();toggleSidebar()")
        span {{$t('ui.livechat')}}
        img(src='/new/img/menu/m-livechat.png')
      router-link.btns(to='/review' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/review'}")
        span {{$tc('ui.review')}}
        img(src='/new/img/menu/m-review.png')
    template(v-else)
      a.btns(href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
        span {{$t('ui.statement')}}
        img(src='/new/img/menu/m-statement.png')
      a.btns(href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
        span {{$t('ui.deposit')}}
        img(src='/new/img/menu/m-deposit.png')
      a.btns(href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
        span VVIP
        //- img(src='/new/img/menu/m-vip.png')
        img(src='/new/img/menu/vvip.png')
    router-link.btns(to='/followUs' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/followUs'}")
      span {{$t('ui.follow')}}
      img(src='/new/img/menu/m-follow.png')
    router-link.btns(to='/freeplay' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/freeplay'}")
      span {{$t('ui.demoplay')}}
      img(src='/new/img/menu/m-demo.png')
    router-link.btns(to='/news' @click.native="toggleSidebar()" :class="{'aaa': currentPath ==='/news'}")
      span {{$t('ui.news')}}
      img(src='/new/img/menu/m-news.png')
    a.btns(v-if="showPrompt && !isIOS" href="javascript:void(0)" @click="triggerDownload")
      span {{$t('ui.downloadapp')}}
      img(src='/new/img/menu/m-app.png')
    a.btns(v-if="isIOS && showTutorial" href='javascript:void(0)' @click="openTutorial()")
      span {{$t('ui.downloadapp')}}
      img(src='/new/img/menu/m-app.png')
    router-link(to='/partners' @click.native="toggleSidebar()")
      //- img.g-op(src='/new/img/menu/partnership-d.gif')
      img.g-op(src='/new/img/menu/group.png')
      img.g-cl(src='/new/img/menu/partner.gif')
  .items.sp(v-if="isLoggedIn")
    a.btns.referral(href="javascript:void(0)" @click="logout")
      span {{$t('ui.logout')}}
      i.fa-solid.fa-arrow-right-from-bracket
</template>
<script>
import language from "@/component/_language.vue"
export default{
  components:{
    language
  },
  data(){
    return{
      currentPath:"",
      showPrompt: false,
      isIOS: false,
      showTutorial: false,
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
  },
  watch:{
    $route (to, from){
      this.currentPath = to.path
    }
  },
  beforeMount(){
    this.getMobile()
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.triggerEvent = e;
      this.showPrompt = true
    });
  },
  mounted(){
    this.currentPath = this.$router.currentRoute.path
  },
  methods:{
    triggerDownload(){
      this.triggerEvent.prompt();
      //user response
      this.triggerEvent.userChoice.then((response) => {
        if (response.outcome === 'accepted') {
          this.showPrompt = false
        } else {
          
        }
      });
    },
    toggleSidebar(){
      if (window.innerWidth < 768){
        $('body').removeClass('hnb');
      }
    },
    getMobile() {
      let isMobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        }
      };

      if (isMobile.iOS()) {
        this.isIOS = true
        this.showTutorial = true
      } else {
        this.isIOS = false
        this.showTutorial = false
      }
    },
    openChat() {
      LiveChatWidget.call("maximize");
    },
    openTutorial() {
      $("#modal-tutorial").modal("show");
    },
    logout() {
      this.$store.dispatch("user/logout").catch(err => {});
    }
  }
}
</script>